import { render, staticRenderFns } from "./CommittedTimberTotalsCard.vue?vue&type=template&id=09cbbe50&"
import script from "./CommittedTimberTotalsCard.vue?vue&type=script&lang=js&"
export * from "./CommittedTimberTotalsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports